import BookingRoleWorkerDto from '@/models/BookingRoleWorkers/BookingRoleWorkerDto';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import WorkerProfileDto from '../Workers/WorkerProfileDto';
import AvailabilityRestrictionSummary from '@/models/AvailabilityRestrictions/AvailabilityRestrictionSummary';

export default class BookingOfferedWorkersViewModel {
    
    selectedBookingRole: BookingRoleDto;
    selectedWorkerId = '';
    selectedWorker: WorkerProfileDto = new WorkerProfileDto();
    selectedBookingRoleWorker: BookingRoleWorkerDto = new BookingRoleWorkerDto();
    bookingRoleWorkers: BookingRoleWorkerDto[] = [];
    payRateForBook = 0;
    minimumPayRateForBook = 0;
    availabilitySummariesForBook: AvailabilityRestrictionSummary[] = [];
    confirmationUrl = '';
}